import React from "react";
import Profile from "../features/profile/Profile";
export default function ProfilePage() {
  return (
    <div>
      <Profile />
    </div>
  );
}
